import { httpClient, postProcessDelete } from '@genai/http-client';
import { AssistantId } from "@genai/assistant";
import { ChatId } from "../model";

export function removeChat(
    assistantId: AssistantId,
    chatId: ChatId,
) {
  return  httpClient(`/assistants/${assistantId}/chats/${chatId}`, {
    method: "DELETE",
  }).then(postProcessDelete);
}
